<!-- A widget to temporarily display multiple alerts.

How to use: Add the <alerts></alerts> in some central location of the
	app, then use the signals (see mounted()) to add alert messages.

-->

<template>
  <div
    class="alerts"
    :class="{
      ...$desktopModeStyles,
      'no-toolbar': isLoginPage && $vuetify.breakpoint.xsOnly,
    }"
  >
    <alert
      v-for="alert in alerts"
      :id="alert.id"
      :key="alert.id"
      :icon="alert.icon"
      :message="alert.message"
      :link="alert.link"
      :translate="alert.translate"
      :color="alert.color"
      :timeout="alert.timeout"
      :hjsuppress="alert.hjsuppress"
    />
  </div>
</template>

<script>
import Alert from '@/components/Alert';

export default {
  components: {
    Alert,
  },
  data() {
    return {
      lastId: 0,
    };
  },
  computed: {
    alerts() {
      return this.$store.state.common.alerts;
    },
    isLoginPage() {
      return this.$route.name === 'login';
    },
  },
  /**
   * Alerts are added via a global event.
   */
  mounted() {
    this.$bus.$on('alert', (args) => {
      this.addAlert(args);
    });
    this.$bus.$on('remove-alert', (alertId) => {
      this.$store.commit('REMOVE_ALERT_BY_ID', alertId);
    });

    // For convenience.
    this.$bus.$on('alert-success', (args) => {
      args.color = 'success';
      args.icon = args.icon || 'check';
      this.addAlert(args);
    });
    this.$bus.$on('alert-error', (args) => {
      args.color = 'error';
      args.icon = args.icon || 'error';
      this.addAlert(args);
    });
    this.$bus.$on('alert-info', (args) => {
      args.color = 'info';
      args.icon = args.icon || 'info';
      this.addAlert(args);
    });
    this.$bus.$on('alert-warning', (args) => {
      args.color = 'warning';
      args.icon = args.icon || 'warning';
      this.addAlert(args);
    });
  },
  methods: {
    addAlert(args) {
      this.lastId++;
      var alert = {
        id: this.lastId,
        message: args.message,
      };
      if (args.link !== undefined) {
        alert.link = args.link;
      }
      if (args.color !== undefined) {
        alert.color = args.color;
      }
      if (args.timeout !== undefined) {
        alert.timeout = args.timeout;
      }
      if (args.icon !== undefined) {
        alert.icon = args.icon;
      }
      if (args.translate !== undefined) {
        alert.translate = args.translate;
      }
      if (args.dismissible !== undefined) {
        alert.dismissible = args.dismissible;
      }
      if (args.hjsuppress !== undefined) {
        alert.hjsuppress = true;
      }
      this.$store.commit('ADD_ALERT', alert);
    },
  },
};
</script>

<style scoped>
.alerts {
  position: fixed;
  left: 0;
  top: 48px;
  z-index: 299; /* 214 is for dialogs, be in front of them */
  width: 100%;
}

.alerts.no-toolbar {
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Alerts.vue